import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PartnershipsPage = lazy(() => import('../pages/partnerships/page'));
const ConsultantPage = lazy(() => import('../pages/consultant/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/a-propos',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/partenariats',
    element: <PartnershipsPage />,
  },
  {
    path: '/devenir-consultant',
    element: <ConsultantPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/conditions',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;